import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import {Assessment, ErgoRiskMatrix, FactorIdentification, FatigueAnalysis, ManualHandling} from '../../swagger/src'
import JobInfo from "../../swagger/src/model/JobInfo";
import {formatDate} from '../utils/datetime'

Vue.use(Vuex)

/* eslint-disable no-new */
const store = new Vuex.Store({
    state: {
        locales: "zh",
        // 风险因数识别
        ergoRiskMatrix: null,
        authorization: window.localStorage.getItem("token") || '',
        // 基本信息的表单验证状态：todo 未验证、begin: 开始验证、fail 验证失败、success 验证成功
        submitStatus: 'todo',
        baseInfoValidateStatus: "todo",
        // 用户信息
        userInfo: {},
        // 左边菜单状态, 默认风险因素识别
        menuActiveItem: "factor",
        // 评估前和评估后激活tab
        tabActiveItem: "before",
        // 开始下载PDF的状态控制;数值改变开始下载
        beginDownloadNum: 0,

        userToQuery: '',
        ergoRiskMatrixes: [],
        filterPage: 0,
        filterPageSize: 15,
        filterTotal: 0,
        sequenceFilter: 0,
        filterSortType: ''
    },
    mutations: {
        setFilterPage(state, page) {
            state.filterPage = page
        },
        setFilterPageSize(state, pageSize) {
            state.filterPageSize = pageSize
        },
        setFilterTotal(state, total) {
            state.filterTotal = total
        },
        setTableData(state, tableData) {
            state.tableData = tableData
        },
        setFilterSortType(state, sortType) {
          state.filterSortType = sortType
        },
        setErgoRiskMatrixes(state, ergoRiskMatrixes) {
            state.ergoRiskMatrixes = ergoRiskMatrixes
        },
        changeLocales(state, {locales}) {
            state.locales = locales
        },
        submitStatus(state, submitStatus) {
            state.submitStatus = submitStatus;
        },
        setJobInfoValidateStatus(state, {jobInfoValidateStatus}) {
            state.jobInfoValidateStatus = jobInfoValidateStatus;
        },
        setAuthorization(state, {authorization}) {
            state.authorization = authorization
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo
        },
        setUserToQuery(state, userToQuery) {
            state.userToQuery = userToQuery
        },
        setMenuActiveItem(state, {menuActiveItem}) {
            state.menuActiveItem = menuActiveItem
        },
        setTabActiveItem(state, {tabActiveItem}) {
            state.tabActiveItem = tabActiveItem
        },
        setSequenceFilter(state, sequenceFilter) {
            state.sequenceFilter = sequenceFilter
        },
        newErgoRiskMatrix(state, ergoRiskMatrix) {
            let _ergoRiskMatrix = null;
            if (ergoRiskMatrix) {
                _ergoRiskMatrix = ergoRiskMatrix;
            } else {
                _ergoRiskMatrix = ErgoRiskMatrix.constructFromObject(
                    {
                        jobInfo: new JobInfo(),
                        deleted: false,
                        assessments: [Assessment.constructFromObject(
                            {
                                sequence: 1,
                                manualHandling: ManualHandling.constructFromObject({}),
                                fatigueAnalysis: FatigueAnalysis.constructFromObject({}),
                                factorIdentification: FactorIdentification.constructFromObject({})
                            }
                        )]
                    }
                );
            }
            state.ergoRiskMatrix = _ergoRiskMatrix
        },
        pushNewAssessment(state, sequence) {
            let assessment = Assessment.constructFromObject(
                {
                    sequence: sequence,
                    manualHandling: ManualHandling.constructFromObject({}),
                    fatigueAnalysis: FatigueAnalysis.constructFromObject({}),
                    factorIdentification: FactorIdentification.constructFromObject({})
                }
            );
            state.ergoRiskMatrix.assessments.push(assessment);
        },
        setJobInfo(state, jobInfo) {
            state.ergoRiskMatrix.jobInfo = jobInfo
        },
        setFatigueAnalysis(state, {sequence, fatigueAnalysis}) {
            this.getters.getAssessment(sequence).fatigueAnalysis = fatigueAnalysis
        },
        setFactorIdentification(state, {sequence, factorIdentification}) {
            this.getters.getAssessment(sequence).factorIdentification = factorIdentification
        },
        setManualHandling(state, {sequence, manualHandling}) {
            this.getters.getAssessment(sequence).manualHandling = manualHandling
        },
        setAssessment(state, {sequence, assessment}) {
            let item = this.getters.getAssessment(sequence);
            Object.keys(assessment).forEach(key => {
                item[key] = assessment[key];
            })
        },
        setBeginDownloadNum(state) {
            state.beginDownloadNum++
        }
    },
    actions: {
        async retrieveErgoRiskMatrixByUser({commit, state}, app) {
            if (!state.userToQuery && !state.userInfo) {
                commit("setErgoRiskMatrixes", []);
                commit("setFilterTotal", 0);
            } else {
                let res = await app.$ergoRiskMatrixControllerApi.getErgoRiskMatrixesByUser(state.userToQuery,
                    {page: state.filterPage, pageSize: state.filterPageSize, sequence: state.sequenceFilter, sortType: state.filterSortType}
                );
                commit("setErgoRiskMatrixes", res.content);
                commit("setFilterTotal", res.totalElements);
                return res
            }
        }
    },
    getters: {
        getAssessment: (state) => (sequence) => {
            return state.ergoRiskMatrix.assessments.filter(a => a.sequence === sequence)[0]
        },
        getTotalRiskFactors: (state, getters) => (sequence) => {
            return getters.getAssessment(sequence).totalRiskFactors || 0;
        },
        getTableData: (state) => {
            let tableData = [];
            console.log(state.ergoRiskMatrixes)

            state.ergoRiskMatrixes.forEach((item, index) => {
                let info = {...item.jobInfo};
                // info.riskLevel = info.riskLevel;
                // console.log(item.riskLevel);

                info.assessId = item.id;
                // console.log(item.createdDate)
                // console.log(new Date(item.createdDate))
                // item.createdDate = item.createdDate.split('.')[0];
                // info.createdDate = formatDate(new Date(item.createdDate));
                // info.createdDate = formatDate(new Date(item.createdDate));
                console.log(info.createdDate)
                // 首次评估时间
                info.firstDate = item.createdDate;
                // 第二次评估时间
                info.secondDate = null;
                if (item.assessments.length === 2 && item.assessments[1].createdDate) {
                    // const createdDate = item.assessments[1].createdDate;
                    // info.secondDate = formatDate(new Date(createdDate));
                    info.secondDate = item.assessments[1].createdDate;
                }
                item.assessments.sort((a,b) => {return a.sequence - b.sequence}).forEach(assessment => {
                    let temp = {};
                    temp.asssessTimes = item.assessments.length;
                    temp.customIndex = index + 1;
                    // 过滤出最近一次评估
                    if (state.sequenceFilter === -1 && temp.asssessTimes > 1 && assessment.sequence === 1) return;

                    // 过滤出第一次评估
                    if (state.sequenceFilter === 1 && assessment.sequence !== 1) return;

                    // 过滤出第二次评估
                    if (state.sequenceFilter === 2 && assessment.sequence !== 2) return;

                    temp.stage = parseInt(assessment.sequence) === 1 ? 'common.assessBefore' : 'common.assessAfter';
                    temp.stageCode = parseInt(assessment.sequence) === 1 ? 'before' : 'after';
                    temp.bodyPart = !assessment.bodyPart ? [] : assessment.bodyPart.split(',').map(item => {
                        return item
                    });
                    temp.liftingIndex = assessment.liftingIndex || '';
                    temp.rwl = assessment.rwl || '';
                    temp.totalRiskFactors = assessment.totalRiskFactors;
                    temp.totalWithHighAndVeryHigh = assessment.totalWithHighAndVeryHigh;
                    temp.index = item.id * 10 + assessment.sequence;
                    tableData.push({...info, ...temp});
                });
            });
            // tableData.sort((a, b) => {
            //     return   a.index -  b.index
            // });
            console.dir(tableData)
            return tableData;
        },
        getSequenceFilter: (state) => {
            return state.sequenceFilter
        },
        getLocales: (state) => {
            return state.locales
        },
    },
    plugins: [createPersistedState({
        storage: window.localStorage,
        // storage: {
        //     getItem: key => Cookies.get(key),
        //     // Please see https://github.com/js-cookie/js-cookie#json, on how to handle JSON.
        //     setItem: (key, value) =>
        //         Cookies.set(key, 11, { expires: 3, secure: true }),
        //     removeItem: key => Cookies.remove(key),
        // },
        reducer(val) {
            return {
                // 只储存state中的assessmentData
                token: val.authorization,
                locales: val.locales,
                userInfo: val.userInfo,
                menuActiveItem: val.menuActiveItem,
                tabActiveItem: val.tabActiveItem,
                ergoRiskMatrix: val.ergoRiskMatrix,
                userToQuery: val.userToQuery,
            }
        }
    })],
    modules: {}
})


export default store
